import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ConfirmModal({
  open,
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  loading = false,
  error = ''
}) {
  const { t } = useTranslation();
  const resolvedConfirmText = confirmText ?? t('Confirm');
  const resolvedCancelText = cancelText ?? t('Cancel');

  if (!open) return null;
  return (
    <div style={styles.backdrop}>
      <div style={styles.modal} role="dialog" aria-modal="true">
        {title ? <div style={styles.title}>{title}</div> : null}
        {description ? <div style={styles.desc}>{description}</div> : null}
        {error ? <div style={styles.error}>{error}</div> : null}
        <div style={styles.actions}>
          <button type="button" onClick={onCancel} disabled={loading} style={styles.cancel}>
            {resolvedCancelText}
          </button>
          <button type="button" onClick={onConfirm} disabled={loading} style={styles.danger}>
            {loading ? t('Deleting…') : resolvedConfirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.35)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modal: {
    background: '#fff',
    borderRadius: 8,
    border: '1px solid rgba(0,0,0,0.1)',
    boxShadow: '0 12px 28px rgba(140,149,159,0.3)',
    maxWidth: 420,
    width: '90%',
    padding: 16
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: '#24292f',
    marginBottom: 8
  },
  desc: {
    fontSize: 14,
    color: '#57606a',
    marginBottom: 8
  },
  error: {
    color: '#b00020',
    background: '#fde7e9',
    border: '1px solid #f5c2c7',
    fontSize: 12,
    borderRadius: 6,
    padding: '6px 8px',
    marginBottom: 8
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 8
  },
  cancel: {
    appearance: 'none',
    border: '1px solid #d0d7de',
    background: '#f6f8fa',
    color: '#24292f',
    padding: '6px 10px',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 14
  },
  danger: {
    appearance: 'none',
    border: '1px solid #d1242f',
    background: '#f85149',
    color: '#fff',
    padding: '6px 10px',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 14
  }
};


